import React from 'react'
import DashboardHomeContent from '../components/DashboardHomeContent'

const Dashboard: React.FC = () => {
  return (
    <div className="min-h-screen">
      <main className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 py-4 sm:py-6 lg:py-8">
        <DashboardHomeContent />
      </main>
    </div>
  )
}

export default Dashboard
